var React = require('react');

function HexagonInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Polygon_24","data-name":"Polygon 24","transform":"translate(13) rotate(90)","fill":"#fff"},[React.createElement("path",{"className":"active-hexagon","d":"M 11.72060108184814 12.5 L 4.279399394989014 12.5 L 0.5870915651321411 6.5 L 4.279399394989014 0.5 L 11.72060108184814 0.5 L 15.41290855407715 6.5 L 11.72060108184814 12.5 Z","stroke":"none","key":0}),React.createElement("path",{"className":"active-hexagon border","d":"M 4.558798789978027 1 L 1.174182891845703 6.5 L 4.558798789978027 12 L 11.44120216369629 12 L 14.8258171081543 6.5 L 11.44120216369629 1 L 4.558798789978027 1 M 4 0 L 12 0 L 16 6.5 L 12 13 L 4 13 L 0 6.5 L 4 0 Z","stroke":"none","fill":"#262626","key":1})]));
}

HexagonInline.defaultProps = {"width":"13","height":"16","viewBox":"0 0 13 16","style":{"transform":"scale(1.01)"}};

module.exports = HexagonInline;

HexagonInline.default = HexagonInline;
